var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TermosDeUsoComponent',{attrs:{"buttons-footer":true,"id-termo":_vm.step.idTermosUso,"titulo":_vm.titulo,"esconder-header":true},on:{"aceito":_vm.proximo,"dataAceite":_vm.bypass,"cancelar":_vm.voltar,"voltar":_vm.voltar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }